import CustomerAccountRegistrationDTO from "features/registration/dtos/CustomerAccountRegistrationDTO";
import { renderDynamicFormFields, setDynamicFormValidationRules, getInitValues } from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import FormFieldDescriptor from "features/shared/forms/dynamicForm/models/FormFieldDescriptor";
import { useForm } from "features/shared/forms/hooks/useForm";
import React, { useEffect } from "react";
import styles from './customerAccountRegistrationForm.module.scss';
import CustomerAccountRegistrationFormBase from "./CustomerAccountRegistrationFormBase";
import CustomerAccountRegistrationFormBaseProps from "./CustomerAccountRegistrationFormBaseProps";
import { getDataDescriptors } from "./customerAccountRegistrationFormHelper";

interface Props extends CustomerAccountRegistrationFormBaseProps {
  basicFormFields: FormFieldDescriptor[];
}

const CustomerAccountRegistrationForm = ({ basicFormFields, additionalFormFields, showAdditionalForm, onSubmit, onBackClick }: Props) => {

  const initialValues = getInitValues(basicFormFields);
 
  // form hook
  const formHandler = useForm({ initialValues });

  const {
    values,
    setValidationRule,
    valideteForm
  } = {...formHandler};

  // side-effects
  useEffect(() => {
    setDynamicFormValidationRules(basicFormFields, setValidationRule);
  }, []);

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let registration: CustomerAccountRegistrationDTO = {}
      registration.registrationDescriptors = getDataDescriptors(values)

      onSubmit(registration);
    }
  };

  // render
  return (
    <div className={styles.formWrapper}>
      <form onSubmit={submitFormHandler}>
        <CustomerAccountRegistrationFormBase
          additionalFormFields={additionalFormFields}
          showAdditionalForm={showAdditionalForm}
          onSubmit={onSubmit}
          onBackClick={onBackClick}
          dynamicForm={{formHandler: formHandler }}
        >
          {renderDynamicFormFields(basicFormFields, { formHandler: formHandler })}
      </CustomerAccountRegistrationFormBase>
      </form>
    </div>
  );
};

export default CustomerAccountRegistrationForm;
